import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "./Tooltip";

export const PupilTools = ({ tools, btnText }) => {
    const [isActive, setIsActive] = useState(false);

    const actionHandler = (callback) => {
        callback();
        setIsActive(false);
    };

    return (
        <>
            {isActive && (
                <div className="page tools tools__pupil">
                    <button onClick={() => setIsActive(!isActive)} className="tools__close-btn" />
                    <div className="tools__items tools__items-pupil">
                        {tools &&
                            tools.map((tool, index) => {
                                const getTooltipText = (title) => {
                                    if (title.includes("move_to_archive") || title.includes("Перенести в архив")) {
                                        return "Функция предназначена для временного удаления ребенка из системы, для переноса из класса в класс, перехода к другому психологу или длительный больничный ребенка. Вы в любой момент можете вернуть ребенка из архива в класс. Не удаляет ребенка.";
                                    }
                                    if (title.includes("delete_pupil") || title.includes("Удалить ученика")) {
                                        return "Навсегда удаляет ребенка и все результаты его тестирований из системы.";
                                    }
                                    return null;
                                };

                                const tooltipText = getTooltipText(tool.title);
                                const needsTooltip = tooltipText !== null;

                                return tool.url ? (
                                    <Link key={index} to={tool.url} className="tools__item">
                                        <div className={needsTooltip ? "tools__item-with-tooltip" : ""}>
                                            <span>{tool.title}</span>
                                            {needsTooltip && (
                                                <Tooltip text={tooltipText}>
                                                    <span className="tooltip-icon">?</span>
                                                </Tooltip>
                                            )}
                                        </div>
                                    </Link>
                                ) : (
                                    <button
                                        key={index}
                                        onClick={() => actionHandler(tool.action)}
                                        className="tools__item"
                                    >
                                        <div className={needsTooltip ? "tools__item-with-tooltip" : ""}>
                                            <span>{tool.title}</span>
                                            {needsTooltip && (
                                                <Tooltip text={tooltipText}>
                                                    <span className="tooltip-icon">?</span>
                                                </Tooltip>
                                            )}
                                        </div>
                                    </button>
                                );
                            })}
                    </div>
                </div>
            )}

            <div className="tools__pupil_open-btn-wrapper">
                <button onClick={() => setIsActive(!isActive)} className="tools__pupil_open-btn">
                    {btnText}
                </button>
            </div>
        </>
    );
};
